var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"my-button"},[_vm._v("\n        "+_vm._s(_vm.displayName)+"\n        "),(!_vm.readOnly)?_c('van-icon',{attrs:{"name":"cross"},on:{"click":_vm.deleteCallback}}):_vm._e()],1),_c('br')])}
var staticRenderFns = []

export { render, staticRenderFns }